import { IVAV } from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

type VAVState = {
  editVAV: IVAV;
  updateDeleteVAV: boolean;
};

const SET_VAV_EDIT = (state: VAVState, payload: IVAV) => {
  state.editVAV = payload;
};

const SET_VAV_UPDATE_DELETE = (state: VAVState, payload: boolean) => {
  state.updateDeleteVAV = payload;
};

export default {
  SET_VAV_EDIT,
  SET_VAV_UPDATE_DELETE,
};
